/* eslint-disable */

export const updateScheduledOrderConstants = {
    UPDATE_SCHEDULED_ORDER_REQUEST: 'UPDATE_SCHEDULED_ORDER_REQUEST',
    UPDATE_SCHEDULED_ORDER_SUCCESS: 'UPDATE_SCHEDULED_ORDER_SUCCESS',
    UPDATE_SCHEDULED_ORDER_FAILURE: 'UPDATE_SCHEDULED_ORDER_FAILURE',
};
